import { useState } from "react";
import { PageHeader, Panel } from "@/components/common";
import { CalendarBlank, FilmSlate, Scissors, MusicNotes } from "@phosphor-icons/react";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const EVENTS = {};
const TYPE = { ep: { icon: FilmSlate, c: "#00E5FF" }, short: { icon: Scissors, c: "#FF007F" }, music: { icon: MusicNotes, c: "#00FF9D" } };

export default function ContentCalendar() {
  const [view, setView] = useState("Weekly");
  return (
    <div>
      <PageHeader icon={CalendarBlank} title="Content Calendar"
        subtitle="Plan episodes, shorts, reels and music across platforms and languages. Drag-and-drop scheduling."
        actions={
          <div className="flex rounded-full border border-white/10 overflow-hidden text-sm">
            {["Weekly", "Monthly", "Language"].map((v) => (
              <button key={v} data-testid={`cal-view-${v}`} onClick={() => setView(v)} className={`px-3 py-1.5 ${view === v ? "bg-white/10 text-white" : "text-zinc-500"}`}>{v}</button>
            ))}
          </div>
        } />
      <div className="grid grid-cols-1 sm:grid-cols-7 gap-3">
        {DAYS.map((d) => (
          <Panel key={d} className="min-h-[180px] p-3">
            <div className="text-xs font-semibold text-zinc-400 mb-3">{d}</div>
            <div className="space-y-2">
              {(EVENTS[d] || []).length === 0 && <p className="text-[11px] text-zinc-600">No scheduled posts</p>}
              {(EVENTS[d] || []).map((e, i) => {
                const cfg = TYPE[e.type];
                const Icon = cfg.icon;
                return (
                  <div key={i} data-testid={`cal-event-${d}-${i}`}
                    className="rounded-lg border p-2 cursor-grab hover:brightness-125 transition-all" style={{ background: `${cfg.c}18`, borderColor: `${cfg.c}44` }}>
                    <Icon size={14} weight="duotone" style={{ color: cfg.c }} />
                    <div className="text-[11px] text-white mt-1">{e.t}</div>
                  </div>
                );
              })}
            </div>
          </Panel>
        ))}
      </div>
    </div>
  );
}
